import {
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import {
  StyledTableCell,
  StyledTableRow,
} from '../../../../../components/molecules/TableWithPagination/UsedComponentsAndImports';
import IsMobile from '../../../../../utils/IsMobile';
import CockpitGoobiesRow from './CockpitGoobiesRow';

const tableHeaders = [
  'Mois',
  'Supposées être équipées',
  'Equipées des Goobies',
  'Non équipées de Goobies',
];

const mockData = [
  {
    anne: 2014,
    supposees: 100,
    equipees: 80,
    nonEquipees: 20,
  },
  {
    anne: 2015,
    supposees: 100,
    equipees: 80,
    nonEquipees: 20,
  },
  {
    anne: 2016,
    supposees: 100,
    equipees: 80,
    nonEquipees: 20,
  },
];

const CockpitGoobiesTable = () => {
  const isMobile = IsMobile();

  return (
    <>
      <Typography variant="h3">Goobies</Typography>
      <TableContainer className="table-with-pagination__table">
        <Table
          sx={{
            borderSpacing: '0 8px !important',
            borderCollapse: 'separate !important',
          }}
          aria-label="simple table"
          stickyHeader
        >
          {!isMobile && (
            <TableHead className="table-header">
              <TableRow>
                {tableHeaders.map((th, i) => (
                  <StyledTableCell key={i}>
                    <Box className="table-header__cell">{th}</Box>
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
          )}

          <TableBody className="table-with-pagination__table-body">
            {mockData.map((d, i) => (
              <StyledTableRow component={Paper} key={i}>
                <CockpitGoobiesRow tracker={d} key={i} />
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default CockpitGoobiesTable;
